import { Divider, Grid } from '@material-ui/core';
import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import * as enums from '../../../../utils/EnumMapping';
import { GridItem } from './GridItem';
import { ProposedTable } from './ProposedTable';
import { LinkedTable } from './LinkedTable';

class PayableDetail extends Component {

    state = {
        groupedPayables: [],
        linkedTransactions: [],
        linkedTransactionsToGroup: [],
        proposedTransactions: [],
        payable: {}
    };

    componentDidMount() {
        console.log(this.props);
        this.callExpandApi()
            .then(res => this.setState({
                groupedPayables: res.data.groupedPayables,
                linkedTransactions: res.data.linkedTransactions,
                linkedTransactionsToGroup: res.data.linkedTransactionsToGroup,
                proposedTransactions: res.data.proposedTransactions,
                payable: res.data.payable
            }))
            .catch(err => console.log(err));
    }

    callExpandApi = async () => {
        const path = '/api/detail/payable';
        const requestObject = {
            "privateId": this.props.row.privateId,
            "type": this.props.row.rowType,
        };
        const response = await axios.post(path, requestObject);
        if (response.status !== 200) throw Error(response.message);
        console.log(response.data);
        return response;
    };

    getTransactionSumAmount = () => {
        let sum = 0;
        this.state.linkedTransactions.map((row) => (sum = sum + row.amount));
        this.state.linkedTransactionsToGroup.map((row) => (sum = sum + row.amount));
        return sum;
    }

    getPayableSumAmount = () => {
        let sum = 0;
        this.state.groupedPayables.map((row) => (sum = sum + row.amount));
        return sum;
    }

    render() {
        return (
            // <form onSubmit={this.handleSubmit}>
            <>
                <h3>{enums.getLabel(enums.objectTypes, this.props.row.rowType)}:</h3>
                <div className='details'>
                    <Grid container spacing={3}>
                        <GridItem label={"Sorszám"} value={this.state.payable.publicId} />
                        <GridItem label={"Megnevezés"} value={this.state.payable.partnerName} />
                        <GridItem label={"Összeg"} value={this.state.payable.amount} type={'amount'} />
                        <GridItem label={"Megjegyzés"} value={this.state.payable.comment} />
                        <GridItem label={"Dátum"} value={this.state.payable.billDate} type={'date'} />
                        <GridItem label={"Teljesítés dátuma"} value={this.state.payable.fulfillmentDate} type={'date'} />
                        <GridItem label={"Fizetési határidő"} value={this.state.payable.paymentDeadline} type={'date'} />
                        <GridItem label={"Fizetési mód"} value={enums.getLabel(enums.paymentMethods, this.state.payable.paymentMethod)} />
                        <GridItem label={"Státusz"} value={enums.getLabel(enums.states, this.state.payable.state)} />
                        <GridItem label={"Fennmaradó összeg"} value={this.state.payable.remainingAmount} />
                    </Grid>
                </div>
                <Divider />
                <h3>Összesítés:</h3>
                <LinkedTable
                    linkedTransactions1={this.state.linkedTransactions}
                    linkedTransactions2={this.state.linkedTransactionsToGroup}
                    groupedPayables={this.state.groupedPayables}
                    type={enums.getLabel(enums.objectTypes, this.props.row.rowType)}
                    amount={this.state.payable.amount} />
                <Divider />

                {/* <h3>Linkelt {enums.getLabel(enums.pluralObjectTypes, this.props.row.rowType)}:</h3>
                <GroupedPayables list={this.state.groupedPayables} />
                <Divider /> */}

                <h3>Ajánlott tranzakciók:</h3>
                <ProposedTable list={this.state.proposedTransactions} />

                {/* <h3>Összesen:</h3> */}
                {/* <SumTable list={this.state.proposedTransactions} /> */}
            </>
            // <h3></h3>
            // <div className="form-actions">
            //     <Button className="btn-submit" variant="contained" color="primary" onClick={this.handleSuccess}>
            //         Mégse
            //     </Button>
            //     <Button className="btn-submit" variant="contained" color="primary" type="submit">
            //         Hozzáadás
            //     </Button>
            // </div>
            // </form>

        )
    }
}

export default withSnackbar(PayableDetail);
